
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import type { Connector } from 'react-redux'
import type { Store } from 'types/index'
import firebase from 'firebase'

import coinsExtended from '../../../selectors/coinsExtended';
import './styles.scss'

class Main extends PureComponent {
  constructor(props){
    super(props)

    this.state = {
      coinsToDelete: null
    }
  }

  componentDidUpdate(prevProps) {
    const { coins } = this.props

    if(!prevProps.coins || !coins) return
    if( prevProps.coins.length === coins.length) return

    const coinsToDelete = coins.filter(c => c.mcap < 3000000)

    this.setState({coinsToDelete})
  }

  addDeleteTag = () => {
    const { coinsToDelete } = this.state
    const updates = {}
    coinsToDelete.forEach(c => {
      updates['coins/'+c.id] = null
    })

    firebase.database().ref().update(updates).then(() => console.log('DIDIT'))
  }

  deletePreciseCounts = () => {
    firebase.database().ref('counts_precise').set({}).then(() => console.log('DIDIT'))
  }


  render(){
    const { coinsToDelete } = this.state
    return (
      <fb className="mainMain">
        <fb onClick={this.addDeleteTag}>Manipulater</fb>
        <fb onClick={this.deletePreciseCounts}>Delete Precise Counts</fb>
        <fb>{coinsToDelete && coinsToDelete.length}</fb>
      </fb>
    )
  }
}

const actionsToProps = {
}

const mapStateToProps = (state: Store) => ({
  coins: coinsExtended(state),
})

const connector: Connector<{}, Props> = connect(mapStateToProps, actionsToProps)
export default connector(Main)



// WEBPACK FOOTER //
// ./src/containers/app/manipulater/index.js